interface ChecklistIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function ChecklistIcon({ 
  size = 14, 
  color = '#4D5762',
  className = '' 
}: ChecklistIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <path
        d="M4.66667 7H9.33333M4.66667 9.33333H9.33333M4.66667 4.66667H5.83333M9.33333 1.16667H4.66667C3.37801 1.16667 2.33333 2.21134 2.33333 3.5V10.5C2.33333 11.7887 3.37801 12.8333 4.66667 12.8333H9.33333C10.622 12.8333 11.6667 11.7887 11.6667 10.5V3.5C11.6667 2.21134 10.622 1.16667 9.33333 1.16667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
